import gql from 'graphql-tag';

const NewCourseMutation = gql`
  mutation DisconnectShopFromTenant($sessionId: String!) {
    disconnectShopFromTenant(sessionId: $sessionId) {
      success
      status
      errors {
        title
        message
      }
    }
  }
`;

export default NewCourseMutation;
